export enum VEHICLE_TYPE {
  CAR = 1,
  BIKE = 2,
  TRUCK = 3,
  HEAVY_VEHICLE = 4,
}
export enum USER_TYPE {
  INDIVIDUAL = 1,
  DEALER = 2,
  SUBADMIN = 3,
  ALL = 4,
}
export enum Notifications_Type {
  // SOCKET= 1,
  PUSH = 2,
  // BROADCAST= 3,
  MAIL = 4,
}
export enum SOLD_STATUS {
  PENDING = 1, // Awaiting action
  SELLER_MARKED_AS_SOLD = 2, // Seller indicated sold
  APPROVED_BY_ADMIN = 3, // Admin confirmed the sold
  REJECTED_BY_ADMIN = 4, // Admin rejected the sold
}

export enum PUSH_TYPE_KEYS {
  DEFAULT = 0,
  BROADCAST = 1,
  INSPECTION = 2,
  INSPECTION_REPORT = 3,
  DEALER_ONBOARD = 4,
  LOAN_REQUEST = 5,
  LOAN_ACCEPTED = 6,
  LOAN_REJECTED = 7,
  MAKE_AN_OFFER = 8,
  DEALER_ACCOUNT_APPROVED = 9,
  DEALER_ACCOUNT_REJECTED = 10,
  ADVERTISE_ACCEPTED = 11,
  ADVERTISE_REJECTED = 12,
  CHAT_NOTIFICATION = 13,
  USER_MARKED_AS_SOLD = 14,
}
export enum SUBSCRIPTION_PLAN {
  MONTHLY = 1,
}
export enum Trim_Type {
  BRAND_NAME = 1,
  MODAL_NAME = 2,
}
export enum ROLE {
  ADMIN = 1,
  SUBADMIN = 2,
}
export enum DISCOUNT_TYPE {
  FLAT = 1,
  PERCENT = 2,
}
export enum BANNER_TYPE {
  TOP = 1,
  BOTTOM = 2,
}
export enum APPROVAL_STATUS {
  PENDING = 0,
  APPROVED = 1,
  REJECTED = 2,
}
export enum UPDATE_TYPES {
  BLOCK = 'block',
  ACCEPT = 'accept',
  REJECT = 'reject',
  ADD_TO_PREMIUM = 'addToPremim',
}

export enum MASTER_DATA {
  BODY_TYPE = 'bodyType',
  FEATURE = 'feature',
  BRAND = 'brand',
  COLOR = 'color',
  DAMAGE = 'damage',
  DRIVE_SYSTEM = 'driveSystem',
  EQUIPMENT = 'equipment',
  ENGINE_CAPACITY = 'engineCapacity',
  FUEL_TYPE = 'fuelType',
  GCC = 'gcc',
  HORSE_POWER = 'horsePower',
  VEHICLE_MODEL = 'vehicleModel',
  VEHICLE_TYPE = 'vehicleType',
  USER_TYPE = 'userType',
}

export enum VEHICLE_CONDITION {
  NEW = 1,
  OLD = 2,
}

export const TRANSMISSION_TYPE = {
  1: 'Manual',
  2: 'Automatic',
} as any;

export enum STEERING_TYPE {
  LEFT = 1,
  RIGHT = 2,
}

export const DISCOUNT_TYPE_NAME: Record<number, string> = {
  1: 'FLAT',
  2: 'DISCOUNT',
};
